import { render, staticRenderFns } from "./MenuItemBoxTransport.vue?vue&type=template&id=9fb6904e&"
import script from "./MenuItemBoxTransport.vue?vue&type=script&lang=js&"
export * from "./MenuItemBoxTransport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports